import { styled, Link } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const PageW = styled('div')`
  padding: 64px 0px 0px 38px;
  position: relative;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 88px 16px;
  }
`;

export const ColumnsW = styled('div')`
  display: flex;
  gap: 32px;

  @media (max-width: 1023px) {
    flex-direction: column;
  }

  @media (min-width: 1920px) {
    justify-content: center;
    margin: 0 auto;
  }
`;

export const PageHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 36px;
  max-width: 1062px;

  @media (max-width: 1023px) {
    margin-bottom: 16px;
  }

  @media (min-width: 1920px) {
    max-width: 100%;
  }
`;

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  width: 537px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: 450px;
    margin-right: 24px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    min-width: 0px;
  }
`;

export const LinkW = styled(Link)`
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
`;

export const NavLinkW = styled(NavLink)`
  color: ${({ theme }) => theme.palette.info.main};
`;

export const Header = styled('div')`
  font-size: 24px;
  font-weight: 700;
`;
